import BasePDF from './BasePDF';

const SchedulePDF = ({ 
  invoice, 
  client, 
  emitter,
  percentages = [30, 40, 30]
}) => {
  
  // Utilise le composant BasePDF en mode "schedule"
  return BasePDF({
    type: 'schedule',
    invoice,
    client,
    emitter,
    showPaymentInfo: true,
    percentages
  });
};

export default SchedulePDF;